export const NotifyAlertProviderContainer = (state) => state.containers.notifyAlertReducer;

// Need to use .get, beucase reducer defaulState was created by using ImmutableJS
export const selectAlert = (state) => NotifyAlertProviderContainer(state).get('alert').toJS();
